/* eslint-disable camelcase */

import type { BaseArchiveResult, DashboardApiArchiveShapeBase } from "@dashboardApi/apis";

export type EngagementLocationSetsUpdateArchivedStateResult =
  | EngagementLocationSetsUpdateArchivedStateErrorResult
  | EngagementLocationSetsUpdateArchivedStateSuccessResult;

export interface EngagementLocationSetsUpdateArchivedStateSuccessResult extends BaseArchiveResult {
  info: string;
  undo_identifier: number;
  undo_data: {
    app_group_id: string;
    archive: boolean;
    reenable: string[];
    location_set_ids: string[];
  };
}

export const isErrorResult = (
  result: EngagementLocationSetsUpdateArchivedStateResult
): result is EngagementLocationSetsUpdateArchivedStateErrorResult => {
  return (result as EngagementLocationSetsUpdateArchivedStateErrorResult).warn !== undefined;
};

export interface EngagementLocationSetsUpdateArchivedStateErrorResult {
  warn: string;
}

export interface PostEngagementLocationSetsUpdateArchivedStateProps extends DashboardApiArchiveShapeBase {
  location_set_ids: string[];
  archive: boolean;
}
